<div class="scroll-to-top" [ngClass]="{'show-scrollTop': windowScrolled}">
    <button type="button" class="btn btn-danger active btn-round" (click)="scrollToTop()">
        <i class="fas fa-chevron-up" ></i>
    </button>
</div>

